import { Amount, BankAccount } from "../../deals/redux/types";
import { Investment } from "../../Investments/redux/types";

const DealPaymentTypes = {
    DEAL_REPAYMENT_REQ: 'DEAL_REPAYMENT_REQ',
    SET_DEAL_REPAYMENT_REQ: 'SET_DEAL_REPAYMENT_REQ'
}
export default DealPaymentTypes;

interface PaymentDeal {
    details?: {
        key: string;
        value: string[] | undefined
    }[],
    bankAccount?: BankAccount;
    currencies?: string[];
    dealType?: string;
    description: string;
    endTime?: string;
    fundingCommitted?: Amount;
    instrumentType?: string;
    minimumInvestment?: Amount[];
    startTime: string;
    targetFundingSize?: Amount;
    title: string;
    terms?: {
        distribution: string;
        tenorInMonths: number;
        equityFundingToDate?: Amount;
        fundingRound?: string;
        interestRates?: {
            ccy: string;
            interestRate: string;
        }[]
    }
}

export interface Payment {
    deal: PaymentDeal;
    investment: Investment;
}

export interface DealPaymentState {
    payment: Payment | undefined;
    loading: boolean;
}